import React from 'react';
import LinkedinIcon from '../../assets/icons/linkedin.svg';

import './AboutUsCard.css';

const AboutUsCard = ({ person }) => {
  return <div className="about-us-card">
    <div className="about-us-photo-wrapper">
      <img className="about-us-card-photo" src={person.photo} alt={person.name || "Person"} />
      <img src={LinkedinIcon} alt="Linkedin" className="linkedin-icon" />
    </div>
    <div className="about-us-card-info">
      <h4>{person.name}</h4>
      <p className="about-us-position">
        {person.position}
      </p>
    </div>
  </div>;
};

export default AboutUsCard;
